var _indexOf = /*#__PURE__*/require('./_indexOf');

function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
}
module.exports = _contains;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_contains.js
// module id = 752
// module chunks = 168707334958949